<template>
  <div class="card-new map-container">
    <div class="map-mobile">
      <div class="map-mobile-img"></div>
      <div class="map-mobile-tabs">
        <div
          v-for="(item, index) in mapItems"
          :key="index"
          :class="['map-mobile-tab', { active: mobileActiveIndex === index }]"
          @click="mobileActiveIndex = index"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="map-mobile-content">
        <div
          v-for="(item, index) in mapItems"
          :key="index"
          :class="['map-mobile-panel', { active: mobileActiveIndex === index }]"
        >
          <div class="map-mobile-nations">
            <div
              v-for="(nationGroup, groupIndex) in item.nations"
              :key="groupIndex"
              class="map-mobile-nation-group"
            >
              <p v-if="nationGroup.region" class="map-mobile-region">
                {{ nationGroup.region }}
              </p>
              <div class="map-mobile-countries">
                <span
                  v-for="(country, countryIndex) in nationGroup.countries"
                  :key="countryIndex"
                  class="map-mobile-country"
                >
                  {{ country }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="map-content card-content animated">
      <div class="know_img">
        <div
          v-for="(item, index) in mapItems"
          :key="index"
          :class="['know_item', { clicked1: activeIndex === index }]"
          :style="item.position"
          @click="setActiveIndex(index)"
          @mouseenter="setActiveIndex(index)"
          @mouseleave="restartAutoSwitch"
        >
          <div class="know_item_circle"></div>
          <div class="item-name">{{ item.name }}</div>
          <div class="know_dialog" :style="item.dialogStyle">
            <h2>{{ item.name }}</h2>
            <div
              v-for="(nationGroup, groupIndex) in item.nations"
              :key="groupIndex"
              class="know_dialog_nation"
              :style="nationGroup.style"
            >
              <p v-if="nationGroup.region">{{ nationGroup.region }}</p>
              <span
                v-for="(country, countryIndex) in nationGroup.countries"
                :key="countryIndex"
              >
                {{ country }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapItems } from "./companyMapConfig";

export default {
  name: "CompanyMap",
  data() {
    return {
      activeIndex: 0,
      mobileActiveIndex: 0,
      autoSwitchInterval: null,
      mapItems,
    };
  },
  mounted() {
    this.startAutoSwitch();
  },
  beforeDestroy() {
    this.clearAutoSwitch();
  },

  methods: {
    setActiveIndex(index) {
      this.clearAutoSwitch();
      this.activeIndex = index;
    },
    startAutoSwitch() {
      this.autoSwitchInterval = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.mapItems.length;
      }, 3000);
    },
    clearAutoSwitch() {
      if (this.autoSwitchInterval) {
        clearInterval(this.autoSwitchInterval);
        this.autoSwitchInterval = null;
      }
    },
    restartAutoSwitch() {
      this.clearAutoSwitch();
      this.startAutoSwitch();
    },
  },
};
</script>

<style lang="scss" scoped>
// 定义变量
$primary-color: #1457df;
$text-primary: #333;
$text-secondary: #666;
$text-light: #999;
$background-color: #ffffff;
$border-color: #e5e5e5;
$box-shadow: 0 4px 14px 0 rgba(12, 37, 91, 0.1);
$transition: 0.3s all ease-out;
$map-image: url("../../assets/images/aboutUs/company_map.png");

// 共用样式
.map-container {
  background: $background-color;
  padding: 70px 0 60px 0;
}

// 移动端样式
.map-mobile {
  display: none;
  width: 100%;

  &-img {
    width: 100%;
    height: 200px;
    background: $map-image no-repeat center center;
    background-size: contain;
    -webkit-background-size: contain;
    -o-background-size: contain;
    margin-bottom: 20px;
  }

  &-tabs {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    margin-bottom: 20px;
    border-bottom: 1px solid $border-color;
  }

  &-tab {
    padding: 12px 16px;
    font-size: 16px;
    color: $text-secondary;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    flex-shrink: 0;
    font-weight: 600;

    &.active {
      color: $primary-color;
      border-bottom-color: $primary-color;
    }
  }

  &-content {
    padding: 0 15px;
  }

  &-panel {
    display: none;

    &.active {
      display: block;

      h2 {
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 15px;
        color: $text-primary;
      }
    }
  }

  &-nations {
    display: flex;
    flex-wrap: wrap;
  }

  &-nation-group {
    width: 50%;
    margin-bottom: 15px;
    padding-right: 10px;
    box-sizing: border-box;
  }

  &-region {
    font-size: 14px;
    font-weight: 500;
    color: $text-primary;
    margin-bottom: 8px;
  }

  &-countries {
    display: flex;
    flex-wrap: wrap;
  }

  &-country {
    display: inline-block;
    font-size: 13px;
    color: $text-secondary;
    margin-right: 10px;
    margin-bottom: 5px;
  }
}

// PC端样式
.map-content {
  width: 1200px;
  margin: 0 auto;

  .know_img {
    position: relative;
    margin: -5px auto 0 auto;
    width: 1200px;
    height: 620px;
    background: $map-image no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;

    .know_item {
      display: flex;
      align-items: center;
      width: 200px;
      position: absolute;

      &:hover,
      &.clicked1 {
        &::after,
        &::before {
          content: "";
          display: block;
          position: absolute;
          left: -2px;
          top: 1px;
          width: 24px;
          height: 24px;
          box-shadow: inset #ffffff 0 0 5px;
          border-radius: 50%;
          animation: loopzoom 2s ease-out infinite;
        }

        &::before {
          opacity: 0;
          animation-delay: 1s;
        }

        .know_item_circle {
          background: #ffffff;
        }

        .know_dialog {
          z-index: 200;
          opacity: 1;
          visibility: visible;
          -webkit-transform: translateY(0);
          -ms-transform: translateY(0);
          transform: translateY(0);
        }
      }

      .know_item_circle {
        width: 12px;
        height: 12px;
        background: #ffffff;
        margin: 4px;
        border-radius: 50%;

        &::after {
          content: "";
          display: block;
          position: absolute;
          left: 0;
          top: 3px;
          width: 20px;
          height: 20px;
          box-shadow: inset #ffffff 0 0 5px;
          border-radius: 50%;
        }
      }

      .item-name {
        margin-left: 11px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        line-height: 25px;
      }

      .know_dialog {
        display: block;
        position: absolute;
        top: -44px;
        left: -205px;
        width: 172px;
        height: 186px;
        box-sizing: border-box;
        padding: 20px;
        background: rgba(255, 255, 255, 1);
        box-shadow: $box-shadow;
        transition: $transition;
        visibility: hidden;
        opacity: 0;
        -webkit-transform: translateY(5px);
        -ms-transform: translateY(5px);
        transform: translateY(5px);

        h2 {
          font-size: 16px;
          font-weight: 500;
          color: rgba(9, 15, 33, 1);
          line-height: 22px;
          text-align: left;
          margin-top: 0;
          margin-bottom: 0;
          text-indent: 0;
        }

        p {
          text-align: left;
          font-size: 14px;
          font-weight: 400;
          color: rgba(9, 15, 33, 1);
          line-height: 30px;
          margin-top: 10px;
          margin-bottom: 10px;
        }

        .know_dialog_nation {
          width: 42px;
          float: left;

          span {
            display: inline-block;
            width: 98px;
            margin-left: 0;
            font-size: 14px;
            font-weight: 400;
            color: rgba(9, 15, 33, 0.4);
            line-height: 30px;
            text-align: left;
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .map-container {
    padding: 30px 0 0 0;
  }

  .map-mobile {
    display: block;
  }

  .map-content {
    display: none;
  }
}

// 动画定义
@keyframes loopzoom {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(3);
    opacity: 0;
  }
}
</style>